import { getActivePinia, type Store } from 'pinia'

type StoreWithReset = Store & { reset(): void }

// Pinia does not expose a public API to enumerate all registered store instances.
// We use a typed cast to the internal `_s` map rather than @ts-ignore so that a
// Pinia major-version break surfaces as a type error instead of silent misbehaviour.
interface PiniaWithStoreMap {
  _s: Map<string, Store>
}

export function resetAllStores() {
  const pinia = getActivePinia()
  if (!pinia) return

  const stores = (pinia as unknown as PiniaWithStoreMap)._s

  stores.forEach((store) => {
    if (Object.prototype.hasOwnProperty.call(store, 'reset') && typeof (store as StoreWithReset).reset === 'function') {
      (store as StoreWithReset).reset()
    } else if (typeof store.$reset === 'function') {
      try {
        store.$reset()
      } catch {
        // $reset() throws on setup stores without a factory snapshot — ignore.
      }
    }
  })
}
